import { isExpired } from "react-jwt";
import posthog from 'posthog-js';
import { postRequest, getRequest } from '../utils/axios';
// import axios from 'axios';


export const authService = {
    login,
    logout,
    register,
    fetchUser,
    tokenNeedsRefresh,
    refreshToken,
};

function login(username, password, onSuccess, onError) {
  return postRequest(
    '/api/token/',
    {'username': username, 'password': password},
    (response) => {
      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      // fetch user config (moved to Login.jsx)
      // fetchUser()

      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function register(data, onSuccess, onError) {
  return postRequest(
    '/api/v1/auth/register/',
    data,
    (response) => {
      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      // fetch user config (moved to Register.jsx)
      // fetchUser()

      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function tokenNeedsRefresh(token) {
  return isExpired(token);
}

function refreshToken(onSuccess, onError) {
  localStorage.setItem('refreshingToken', true);
  return postRequest(
    '/api/token/refresh/',
    {'refresh': localStorage.getItem('refreshToken')},
    (response) => {
      const accessToken = response.data.access;
      const newRefresh = response.data.refresh;
      localStorage.setItem('accessToken', accessToken);
      if (newRefresh) {
        localStorage.setItem('refreshToken', newRefresh);
      }
      localStorage.setItem('refreshingToken', false);
      console.log("got a new token")
      if (onSuccess){
        return onSuccess(accessToken)
      }
    },
    (error, response) => {
      // log the user out if their refresh failed
      localStorage.setItem('refreshingToken', false);
      authService.logout()
      if (onError){
        console.log("returning onError")
        return onError(error, response)
      }
    }
  )
}


function identifyUser(user) {
  if (!user?.identity?.id || !process.env.REACT_APP_POSTHOG_KEY) return;
  posthog.identify(String(user.identity.id), { email: user.identity.email });
  if (user.identity.is_staff) {
    posthog.stopSessionRecording();
  }
}

function fetchUser(onSuccess, onError) {
  return getRequest(
    '/api/v1/user-config/',
    (response) => {
      localStorage.setItem('currentUser', JSON.stringify(response.data));
      identifyUser(response.data);
      if (onSuccess){
        onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        onError(error, response)
      }
    }
  )
}


function logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('refreshingToken');
    window.location = '/'
}